import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { TabDialogComponent } from './tab-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    InputModule,
    ButtonModule
  ],
  declarations: [TabDialogComponent],
  entryComponents: [TabDialogComponent],
  exports: [TabDialogComponent]
})
export class TabDialogModule { }
